module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-M15-clean-f9a81aacc924320090da12ec3d7b4bcf.png";